import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

export const useGetPequal = () => {
  // const [prequalData, setPrequalData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const {
    data: prequalData,
    isLoading,
    mutate,
  } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/calculator/pre-qual`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: () => {
        // @ts-ignore
        setOpenModal(true);
        // setPrequalData(data?.data);
      },
    }
  );
  return {
    mutate,
    prequalData,
    isLoading,
    openModal,
    setOpenModal,
  };
};

export const useGetPequalFailure = () => {
  // const [prequalData, setPrequalData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const {
    data: prequalData,
    isLoading,
    mutate,
  } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/user/prequal`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: () => {
        // @ts-ignore
        setOpenModal(true);
        // setPrequalData(data?.data);
      },
    }
  );
  return {
    mutate,
    prequalData,
    isLoading,
    openModal,
    setOpenModal,
  };
};
